/*
 * compatibility mode
 */
jQuery.noConflict();

(function($) {
    var headerElement;
    var headerOffsetTop;
    // executed after page source has been loaded
    $(document).ready(function() {
        handleResponsiveNavigationEvents();
        handleAccordionEvents();
        initLinks();
        initServiceContactSelectbox();
        initAlphabeticalNavigations();
        initServicesSearch();
        initImageCaption();
        initPopover();
        // initFixInfonetStyles();
        initSearchSubmit();
        initToTopLink();
        initServicesExpandAllLink();
        initSlider();
        initReadspeaker();
        initDesktopNavigation();

        initFeUserRegisterUsergroup();
        initFemanagerUsergroup();

        initNavigator();
        accessibleMainNavigation();

        fixVideoStyles();

        initPhoneBookSearchFocus();

        initConwordButtons();

        setTimeout(function(){
            initAlertContentElement();
        }, 1000);

        setTimeout(function(){

            navigationOffsetTop = $('.desktop-mainnavigation-outer').offset().top-90;
            initFixedStyleForElement($('.desktop-header-outer'), 40);
            initFixedStyleForElement($('.desktop-mainnavigation-outer'), navigationOffsetTop);

            $(window).on('scroll', () => {
                initFixedStyleForElement($('.desktop-header-outer'), 40);
                initFixedStyleForElement($('.desktop-mainnavigation-outer'), navigationOffsetTop);
            });

        }, 500);


        if($('.news-amenu-container').length > 0){
            initAmenu();
        }
    });


    $( window ).resize(function() {
        initDesktopNavigation();
        navigationOffsetTop = $('.desktop-mainnavigation-outer').offset().top-90;
        initFixedStyleForElement($('.desktop-mainnavigation-outer'), navigationOffsetTop);
    });



    function accessibleMainNavigation () {
        $( ".desktopnavigation--level1 > .desktopnavigation--item > a" ).focus(function () {
            $( ".desktopnavigation--level1 > .desktopnavigation--item").removeClass('focused');
            $(this).parent().addClass("focused");
            $(window).on( "keydown", function (event) {
                // escape key has number 27!!
                if ( event.which == 27 ) {
                    $( ".desktopnavigation--level1 > .desktopnavigation--item").removeClass('focused');
                    $(window).off("keydown");
                }
            } )
        });

    }

    function initNavigator () {
        if ($('.navigator .infobox .content').length > 0) {
            $('.navigator .infobox .content').each(function(){
                $(this).height($(this).width() * 0.8);
            });
        }
    }

    function initFixedStyleForElement(elem, positionToBeFixedAt){
        if ($(window).width() >= 768) {
            var curScrollPos = $(document).scrollTop();
            if(curScrollPos >= positionToBeFixedAt){
                elem.addClass('fixed-state');
            }else{
                elem.removeClass('fixed-state');
            }
        }
    }

    function initPopover(){
        $('.open-popover').popover();

        $(document).keyup(function (event) {
            if (event.which === 27) {
                $('.open-popover').popover('hide');
            }
        });
        $('body').on('click', function (e) {
            //did not click a popover toggle or popover
            if ($(e.target).data('toggle') !== 'popover'
                && $(e.target).parents('.popover.in').length === 0) {
                $('[data-toggle="popover"]').popover('hide');
            }
        });

    }

    function initToTopLink(){
        $('a.toplink.scroll-direct').on('click', function(e){
            e.preventDefault();
            $("html, body").animate({scrollTop: 0}, 750, 'swing');
            return false;
        });
    }

    function handleResponsiveNavigationEvents() {



        // event fires immediately when the show instance method is called
        $("#hauptnavigation button:not('[popovertarget]')").on('click', function (e) {
            if( $(this).hasClass('mainnavigation--toggle__search') ) {
                $('.page').addClass('page__searchformopen');
            }
            else {
                $('.page').addClass('page__mainnavopen');
            }
        });

        // event is fired when a collapse element has been hidden from the user (will wait for CSS transitions to complete)
        $('#hauptnavigationsinhalt').on('hidden.bs.collapse', function (e) {
            $('.page').removeClass('page__mainnavopen').removeClass('page__searchformopen');
        });

        $('.mainnavigation--togglelvl2').on('click', function(e){
            var mainnavigation = $('.mainnavigation');
            // open level 2
            if( !$(mainnavigation).hasClass('mainnavigation__level2') ) {
                $(mainnavigation).addClass('mainnavigation__level2');
                $(this).parent().addClass('mainnavigation--item__level2open');
            }
            // close level 2
            else {
                $(mainnavigation).removeClass('mainnavigation__level2');
                $(this).parent().removeClass('mainnavigation--item__level2open');
            }
        });

        $(document).on('click', '.mainnavigation__level2 .mainnavigation--level1 > .mainnavigation--item > .mainnavigation--link', function(e){
            $('.mainnavigation').removeClass('mainnavigation__level2');
            $(this).parent().removeClass('mainnavigation--item__level2open');
            return false;
        });
    }

    /**
     * adds icon to each internal link
     * TODO: check if we really need this!
     */
    function initLinks() {
        $('a.internal-link').each(function(){
            $(this).prepend('<span class="lara-icon-angle-right"></span>');
        });

        $('.link__download').each(function(){
            var linkAttrHREF = $(this).attr('href');
            var hrefParts = linkAttrHREF.split(".");
            // we have links that point to an external form, thus length is 1 and they end up with the full href as class
            if (hrefParts.length > 1 && hrefParts[hrefParts.length-1].split('/').length === 1) {
                var fileType = hrefParts[hrefParts.length-1];
                $(this).addClass(fileType);
            }
        });
    }

    /**
     *
     */
    function handleAccordionEvents(){
        $('.accordion--content').on('show.bs.collapse', function (e) {
            // add class for bold text
            $(this).parent().find('.accordion--toggle').addClass("text--weight__bold");
        });
        $('.accordion--content').on('hide.bs.collapse', function (e) {
            // remove class for bold text
            $(this).parent().find('.accordion--toggle').removeClass("text--weight__bold");

        });
        $('.accordion--content').on('shown.bs.collapse', function (e) {
            // check if opened accordion is in viewport or not,
            // if not scroll to it (this avoids content from being out of the viewport,
            // when open accordions are switched)
            var accordionTop = $(this).parent().offset().top;
            var windowTop = $(window).scrollTop();
            if(accordionTop < windowTop) {
                $("html, body").animate({ scrollTop: accordionTop }, "200");
            }
        });
    }

    /*
     *   makes contact data in services accessable via selectbox and searchfield
     */
    function initServiceContactSelectbox(){
        // if there is a contact block inside the service
        $('.service--contactblock').each(function(){

            // if there are are more than 3 contact blocks
            if( $('.rolecontainer').length > 3 ) {

                $('.service--contact').addClass('service--contact__selectbox');
                // add selectbox and search form
                var contactselect = $(this).parent().find('.service--contactselect');
                $(contactselect).html('<p class="service--contactselectintro">'+$(contactselect).data('label')+'</p><select class="service--contactselectbox" name="contactselectbox"><option value="">Bitte wählen</option></select>');

                var contactselectbox = $(this).parent().find('.service--contactselectbox');

                // get data from
                $(this).find('.rolecontainer').each(function(){
                    var roleContainerTitle = $(this).find('.rolecontainer--title').html();
                    var roleContainerDataId = $(this).data('id');
                    $(contactselectbox).append('<option value="'+roleContainerDataId+'">'+roleContainerTitle+'</option>');
                });
            }
        });

        $(document).on('change', '.service--contactselectbox', function(e){
            var roleContainerClass = '.'+$(this).val();
            $(this).parent().parent().find('.rolecontainer').removeClass('active');
            $(this).parent().parent().find(roleContainerClass).addClass('active');
        });
    }

    function initAmenu(){
        $('.collapse-title').each(function(){
            var idText = 'collapse--' + $(this).find('span').text();
            $(this).attr('href', '#'+idText);
            $(this).next('div').attr('id', idText);
        });
    }

    function initAlphabeticalNavigations(){
        $('.alphabeticalNavigation').listnav({
            includeAll: true,
            noMatchText: 'Für diesen Buchstaben gibt es keine passenden Einträge.',
            includeNums: false,
            initLetter: 'a',
            removeDisabled: true,
            allText: 'Alle',
            showCounts: false,
            includeOther: true,
        });
        if($('.ln-letters').length > 0){
            $('.ln-letters a').each(function(){
                if($(this).hasClass('all')) {
                    $(this).attr('title', 'Zeige alle Dienstleistungen.');
                }else if($(this).html() == '...') {
                    $(this).html('ÄÖÜ')

                }else{
                    var char = $(this).html();
                    $(this).attr('title', 'Zeige Dienstleistungen mit dem Anfangsbuchstaben \"' + char + '\".');
                }

            });
        }
        if( !$('.a').hasClass('ln-selected') ) {
            $('.a').trigger('click');
        }
    }

    function initServicesSearch(){
        var readyToClose = false
        if($('#sevicesSearchInput').length > 0 && $('#servicesListForSearch a').length > 0){
            var availableServices = [];
           $('#servicesListForSearch a').each(function(){
               var obj = {value: $(this).html(), link: $(this).attr('href')};
                availableServices.push(obj);
           });
           $('#servicessearch-form').on('submit', function(){
                return false;
           });
            $( "#sevicesSearchInput" ).autocomplete({
                source: availableServices,
                open: function() {
                    $(this).autocomplete("widget")
                        .appendTo("#resultList-servicesSearch")
                        .css("position", "static");
                },
                select: function( event, ui ) {
                    if(ui.item.link.length > 0){
                        window.location.href = ui.item.link
                    }

                },
                response: function(event, ui) {
                    // ui.content is the array that's about to be sent to the response callback.
                    if (ui.content.length === 0) {
                        $("#empty-message").text("Es konnten keine Ergebnisse gefunden werden. Bitte passen Sie ihre Suche an und versuchen Sie es erneut.");
                        $("#empty-message").show();
                    } else {
                        $("#empty-message").hide();
                    }
                }
            }).focus(function(){
                // The following works only once.
                // $(this).trigger('keydown.autocomplete');
                // As suggested by digitalPBK, works multiple times
                $(this).data("uiAutocomplete").search($(this).val());
            });

            $('#servicessearch-form .lara-icon-search').on('click', function(){
                $('#sevicesSearchInput').focus();
            });
        }
    }
    
    function initMagnificpopup(){
        $('.magnificpopup').magnificPopup({
            type: 'image'
            // other options
        });
    }

    function initImageCaption(){
        $('.news-single-imgcaption').each(function(){
            if($(this).text() === ''){
                $(this).hide();
            }
        });
    }

    function initFixInfonetStyles(){
        $('.external-link').each(function(){
            $(this).addClass('link__external');
        });
        $('.internal-link').each(function(){
            $(this).addClass('link');
        });

    }

    function initSearchSubmit(){
        $('form .lara-icon-search').on('click', function(){
            $(this).closest('form').submit();
        });
    }

    function initServicesExpandAllLink(){
        $('#dl-expand-all, #dl-close-all').on('click', function(){
            var method = $(this).data('method');
            if($(this).hasClass('active')){
                $(this).parent().find('a').addClass('active');
                $(this).removeClass('active');
            }else{
                $(this).parent().find('a').addClass('active');
                $(this).addClass('active');
            }
            $('.panel-collapse').collapse(method);

            return false;
        });
    }

    function initSlider(){
        var sliders = [];

        var defaultConfig = {
            320: {
                slidesPerView: 1,
                spaceBetween: 20
            },
            580: {
                slidesPerView: 2,
                spaceBetween: 30
            },
            992: {
                // slidesPerView: slidesPerViewOverride > 0 ? slidesPerViewOverride : 3,
                slidesPerView: 3,
                spaceBetween: 40
            },
            1200: {
                slidesPerView: 4,
                spaceBetween: 40
            }
        }

        var complementaryContentConfig = {
            320: {
                slidesPerView: 1,
                spaceBetween: 20
            },
            580: {
                slidesPerView: 2,
                spaceBetween: 40
            },
            768: {
                slidesPerView: 1,
                spaceBetween: 40
            }
        };

        $('.swiper-container').each(function(index, element){
            var elem = $(this);
            var slidesPerViewOverride = 0;

            var isComplementaryContent = $(this).parents('.complementaryContent').length > 0;
            if (isComplementaryContent) {
                slidesPerViewOverride = 1;
            }

            $(this).addClass('s'+index);
            $(this).parent().find('.swiper-button-next').addClass('r'+index);
            $(this).parent().find('.swiper-button-prev').addClass('l'+index);

            var slider = new Swiper(this, {
                slidesPerView: slidesPerViewOverride > 0 ? slidesPerViewOverride : 4,
                spaceBetween: 30,
                navigation: {
                    nextEl: '.r'+index,
                    prevEl: '.l'+index,
                },
                keyboard: {
                    enabled: true,
                },
                // mousewheel: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },

                // breakpointsBase: 'container',
                breakpoints: isComplementaryContent ? complementaryContentConfig : defaultConfig,

                nextButton: '.r'+index,
                prevButton: '.l'+index,

                onProgress: function(e){
                    if(e.isBeginning){
                        $('.l'+index).hide();
                        $('.r'+index).show();
                    } else if(e.isEnd){
                        $('.r'+index).hide();
                        $('.l'+index).show();
                    } else {
                        $('.r'+index).show();
                        $('.l'+index).show();
                    }
                }
            });
            sliders.push(slider);
        });
    }

    function initFeUserRegisterUsergroup(){
        $('#registrationEmailDomain').on('change', function(){
            var selectedVal = $(this).find(':selected').data('usergroup');
            $('#tx-srfeuserregister-pi1-usergroup').val(selectedVal);
        });
    }

    function initFemanagerUsergroup(){
        if($('#js_username').length < 1) {
            return false;
        }
        $('#js_username').on('keypress', function (event) {
            var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
            if (key === '@' || key === 64) {
                event.preventDefault();
                return false;
            }
        });
        document.querySelector('#js_username').addEventListener('change',function(){
            var usernameVal = this.value;
            var e = document.getElementById("femanager_field_usergroup");
            var domainVal = e.options[e.selectedIndex].text;
            document.querySelector('#femanager_field_username').value = usernameVal + '@' + domainVal;
        });
        document.querySelector('#femanager_field_usergroup').addEventListener('change',function(){
            var domainVal = this.options[this.selectedIndex].text;
            var e = document.getElementById("js_username");
            var usernameVal = e.value;
            document.querySelector('#femanager_field_username').value = usernameVal + '@' + domainVal;
        });
    }

    function initAlertContentElement(){
        var modalId = '#alertContentModal';
        var cookieName = 'alert-content-version-shown';
        var savedCookieVal = parseInt(Cookies.get(cookieName), 10);
        var currCookieVal = 0;

        var elementsToCheck = jQuery($(modalId).find('.custom-modal-content'));
        elementsToCheck.each(function(index, element) {
            var elementValue = parseInt(element.dataset.curcookieval, 10);
            currCookieVal = Math.max(currCookieVal, elementValue);
        })

        // check if we need to show the modal
        if($(modalId).find('.custom-modal-content').length === 0){
            $(modalId).find('.default-message').css('display', 'block');
            currCookieVal = Date.now();
            Cookies.set(cookieName, currCookieVal, { expires: 1 });
            return false;
        }
        $('.desktopnavigation--item__bell').addClass('active');
        $('.alertContentElementCircle').addClass('active');
        if(savedCookieVal === undefined || savedCookieVal !== currCookieVal){
            $(modalId).modal({
                backdrop: 'static'
            });
            Cookies.set(cookieName, currCookieVal, { expires: 1 });
        }
    }

    function debugAlertContentElement(){
        var modalId = '#alertContentModal';
        $(modalId).modal({
            backdrop: 'static'
        });
    }
    window.debugAlertContentElement = debugAlertContentElement;

    function initReadspeaker(){
        var f = 0;
        $('#toggleReadspeaker, #quickNavReadspeaker').on('click', function(e){
            e.preventDefault();
            if(f == 0) {
                f = 1;
                $('.readspeaker-container').addClass('show');
                $("#readspeaker_button1").css('display', 'block');
                if(!$("#readspeaker_button1").hasClass("rsplaying")) {
                    $("span.rsplay").trigger("click");
                }
            }else if(f == 1) {
                f = 0;
                $('.readspeaker-container').removeClass('show');
                $("#readspeaker_button1").css('display', 'none');
                if($("#readspeaker_button1").hasClass("rsplaying")) {
                    $(".rsbtn_stop").trigger("click");
                }
            }
        });
    }

    function initDesktopNavigation(){
        if ($(window).width() >= 768) {
            var selector = ('.desktop-header-outer');
            var headerHeight = parseInt($(selector).css('top')) + parseInt($(selector).outerHeight());
            var headerImageHeight = $('.headerimage--image').outerHeight();
            var offset = 50;
            // aoply headerHeight to background image as min height
            if(headerImageHeight < headerHeight+offset){
                $('.headerimage--image').css('min-height', headerHeight+offset);
            }
        }else{
            $('.headerimage--image').css('min-height', '');
        }
    }

    function fixVideoStyles(){
        $('.video-embed.ratio').each(function(){
            $(this).closest('.ce-gallery.ce--gallery').css('float', 'none');
            $(this).closest('.ce-column ').css('float', 'none');
        });
    }

    function initPhoneBookSearchFocus(){
        if ($('#tx_larafe_personsearch-searchWord').length){
            $( "#tx_larafe_personsearch-searchWord" ).focus();
        }
    }

    function matomo_track(category,action){
        if(typeof _paq !== 'undefined') {
            _paq.push(['trackEvent', category, action, 1]);
            return true;
        }
        return false
    }
    // also used from the event listener
    window.matomo_track = matomo_track;

    function initConwordButtons() {
        const languageMenu = document.querySelector('.language-menu');
        if (languageMenu) {
            document.querySelector('body').insertAdjacentHTML('beforeend', '<div class="language-menu__backdrop"></div>');

            // close the layer on pressing ESC
            document.addEventListener('keydown', function(event) {
                if (event.key === 'Escape' || event.keyCode === 27) {
                    try {
                        languageMenu.hidePopover();
                    } catch (e) {
                        console.error(e);
                    }
                }
            });

            document.querySelector('.language-menu__backdrop').addEventListener('click', function() {
                try {
                    languageMenu.hidePopover();
                } catch (e) {
                    console.error(e);
                }
            })

            languageMenu.addEventListener('click', function (e) {
                // check if the event target is a button
                if (e.target && e.target.closest('button')) {
                    // get lang attribute and pass this on to conword
                    const targetLanguage = e.target.closest('button').getAttribute('lang');
                    document.querySelector('#language-menu').hidePopover();
                    if (!targetLanguage) {
                        return;
                    }
                    try {
                        Conword.translate(targetLanguage);
                        matomo_track('Translation change: ' + targetLanguage, location.href);
                    } catch (e) {
                        console.error(e);
                    }

                }
            })
        }
    }

})(jQuery);
